import { Component, Input, OnInit } from '@angular/core';
import { KbnStatus, LIST_PERIOD_CONSTANT, OfficeType, PERIOD_CONSTANT } from '@core/constants';
import { Utils } from '@core/helper';
import { TitleType } from '@core/models/enums';
import { DynamicLabelModel, YesNoIndicatorConfigModel } from '@core/models/models';
import { CommonHelper, SessionContextService } from '@core/services/common';

@Component({
  selector: 'yes-no-indicator',
  templateUrl: './yes-no-indicator.component.html',
  styleUrl: './yes-no-indicator.component.scss'
})

export class YesNoIndicatorComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() config: YesNoIndicatorConfigModel = new YesNoIndicatorConfigModel();
  labelConfig: DynamicLabelModel = new DynamicLabelModel();
  TitleType = TitleType;
  displayText: string = '';
  isShow: boolean = false;
  lstPeriodValue:any[] = [];
  morningObj: any = null;
  afternoonObj: any = null;
  eveningObj: any = null;
  allDayObj: any = null;
  officeType: number = OfficeType.notSupport;
  constructor(
    private sessionContextService: SessionContextService,
  ) { }

  async ngOnInit(): Promise<void> {
    const officeSelected = this.sessionContextService.getOfficeSelected<any>();
    this.officeType = officeSelected?.officeType || OfficeType.notSupport;
    if (this.data && this.data.length > 0 && this.officeType !== OfficeType.notSupport) {
      let arrayData: any[] = this.data || [];
      if (arrayData.length > 0) {
        // Filter lấy data 1 giờ duy nhất và gần với hiện tại nhất.
        arrayData = this.priorizeKiroku(arrayData); // sort by priority schedule last
        arrayData = CommonHelper.filterLatestByPeriod(arrayData);
        const currentData: any[] = this.getCurrentPeriodData(arrayData) || [];
        if(currentData.length > 0) {
          if (Utils.isNyusho(this.officeType)) {
            await this.processDataByPeriod(currentData);
            this.lstPeriodValue = LIST_PERIOD_CONSTANT.map(period => this.getDataObjByPeriod(period));
          } else if (Utils.isTsusho(this.officeType)) {
            this.allDayObj = this.mapValue(currentData[0]);
            this.lstPeriodValue = [PERIOD_CONSTANT.ALL_DAY].map(period => this.getDataObjByPeriod(period));
          }
        }
      }
    }
  }

  private priorizeKiroku(arrayData: any) {
    const kirokuMap = new Map<string, any>();

    arrayData.forEach((item:any) => {
      const key = this.createKirokuKey(item);
      const existingItem = kirokuMap.get(key);

      const shouldReplace =
        existingItem?.scheduled_oral === true &&
        item?.scheduled_oral === false;

      if (!existingItem || shouldReplace) {
        kirokuMap.set(key, item);
      }
    });
    return Array.from(kirokuMap.values());
  }

  private createKirokuKey(item: any): string {
    return JSON.stringify({
      date: item.date ?? null
    });
  }

  processDataByPeriod(lst:any[]){
    lst.forEach((obj: any) => {
      if (!Utils.isNullOrEmpty(obj?.date)) {
        const period = CommonHelper.getPeriodByDate(obj?.date);
        switch (period) {
          case PERIOD_CONSTANT.MORNING:
            this.morningObj = this.mapValue(obj);
            break;
          case PERIOD_CONSTANT.AFTERNOON:
            this.afternoonObj = this.mapValue(obj);
            break;
          case PERIOD_CONSTANT.EVENING:
            this.eveningObj = this.mapValue(obj);
            break;
          default:
            break;
        }
      }
    });
  }

  getDataObjByPeriod(period:any){
    if (!period) return null;
    let periodObj = null;
    switch (period) {
      case PERIOD_CONSTANT.MORNING:
        periodObj = this.morningObj;
        break;
      case PERIOD_CONSTANT.AFTERNOON:
        periodObj = this.afternoonObj;
        break;
      case PERIOD_CONSTANT.EVENING:
        periodObj = this.eveningObj;
        break;
      default:
        periodObj = this.allDayObj;
        break;
    }
    return periodObj;
  }

  mapValue(item:any){
    // const isShow = item?.status_kbn > 0 || false;
    if (!item) return null;
    const labelConfig = { ...this.labelConfig };
    let displayText = "〇";
    if (item.status_kbn === KbnStatus.STATUS_CANCEL) {
      displayText = "✕";
    } else if (item.status_kbn === KbnStatus.STATUS_CARRY_OUT) {
      displayText = "〇";
    }
    if (item?.scheduled_oral) {
      displayText = this.TitleType.schedule;
    }
    if (item.attention_flg) labelConfig.highlight = true;
    return {
      displayText,
      labelConfig
    }
  }

  getCurrentPeriodData(dataArray: any[]): any[] {
    if (!Array.isArray(dataArray) || dataArray.length === 0) return [];
    let currentPeriod: any = null;

    currentPeriod = CommonHelper.getCurrentPeriod();

    if (!currentPeriod) return []; // Nếu không có khoảng thời gian phù hợp.
    
    // Lọc danh sách dữ liệu thuộc khoảng thời gian hiện tại.
    return dataArray?.filter(item => {
        const itemHour = new Date(item.date).getHours();
        // giờ bắt đầu luôn luôn là 00:00 sáng của period morning.
        const start = parseInt(PERIOD_CONSTANT.MORNING.START?.split(':')[0], 10);
        // giờ kết thúc theo period hiện tại.
        const end = parseInt(currentPeriod.END.split(':')[0], 10);
        return itemHour >= start && itemHour <= end;
    });
  }
}
